import { KatTab, KatTabs } from '@amzn/katal-react';
import React, { useContext } from 'react';
import CorrespondenceTab from '../CorrespondenceTab';
import OverviewTab from '../OverviewTab';
import styled from 'styled-components';
import { CaseDetailsConstants } from 'src/constants/ProjectConstants';
import URLFormatter from 'src/routes/helpers/URLFormatter';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

export const TabsContainer = styled.div`
  flex: 1;
  box-shadow: rgba(35, 47, 62, 0.1) 0px 0px 8px;
  kat-tabs {
    --header-border-color: transparent;
    --header-background: ${({ theme }) => theme.colors.Snow};
    --label-font-size: 1rem;
    --label-font-weight: 700;
    --label-padding: 1.25rem;
    --label-margin-bottom: 1rem;
  }
`;

const TAB_ID = {
  CASE_DETAILS: '1',
  COMMUNICATION: '2',
};

const TabLayout = () => {
  const urlFormatter = new URLFormatter(window.location.href);
  const selectedTab = urlFormatter.getTab() || TAB_ID.CASE_DETAILS;

  const { caseDetailsBundle } = useContext(TranslationContext);

  return (
    <TabsContainer data-testid="tab-layout">
      <KatTabs selected={selectedTab}>
        <KatTab
          data-testid="case-detail-tab"
          tabId={TAB_ID.CASE_DETAILS}
          label={caseDetailsBundle.getMessage(
            CaseDetailsConstants.TAB_CASE_DETAILS,
          )}
          onClick={() => {
            window.location.href = urlFormatter
              .setTab(TAB_ID.CASE_DETAILS)
              .buildURLString();
          }}
        >
          <OverviewTab />
        </KatTab>
        <KatTab
          data-testid="communication-tab"
          tabId={TAB_ID.COMMUNICATION}
          label={caseDetailsBundle.getMessage(
            CaseDetailsConstants.TAB_COMMUNICATION,
          )}
          onClick={() => {
            window.location.href = urlFormatter
              .setTab(TAB_ID.COMMUNICATION)
              .buildURLString();
          }}
        >
          <CorrespondenceTab />
        </KatTab>
      </KatTabs>
    </TabsContainer>
  );
};

export default TabLayout;
